const DEFAULT_WIDTH = 120;
const DEFAULT_MIN = 60;
const DEFAULT_MAX = 1000;

/**
 * Gives every column an explicit `width` (width → minWidth → maxWidth → 120), clamped to
 * [minWidth ?? 60, maxWidth ?? 1000]. Same behavior the vulns tables apply today.
 *
 * @param {Object[]} cols - engine columns
 * @return {Object[]} columns with explicit `width`, `minWidth` and `maxWidth`
 */
const normalizeColumns = (cols) => cols.map((col) => {
  const min = Number.isFinite(col.minWidth) ? col.minWidth : DEFAULT_MIN;
  const max = Number.isFinite(col.maxWidth) ? col.maxWidth : DEFAULT_MAX;

  let width;

  if (Number.isFinite(col.width)) {
    width = col.width;
  } else if (Number.isFinite(col.minWidth)) {
    width = col.minWidth;
  } else if (Number.isFinite(col.maxWidth)) {
    width = col.maxWidth;
  } else {
    width = DEFAULT_WIDTH;
  }

  if (width < min) width = min;
  if (width > max) width = max;

  return {
    ...col,
    width,
    minWidth: min,
    maxWidth: max
  };
});

export default normalizeColumns;
